/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum BaseGridInternalColumnTypeEnum {
    ROW_KEY = 1,
    MULTI_ROW_SELECT = 2,
    INDICATION = 3,
    OPTIONS = 4,
    IS_NEW = 5,
    IS_DELETED = 6,
    IS_BOLD = 7,
    IS_META = 8,
}
